import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircleOff } from "lucide-react";

const useStyles = makeStyles((theme) => ({
    card: {
        width: "100%",

        backgroundColor: "#FFFFFF",
        margin: "auto",
        textAlign: "center",
        padding: "36px",
        border: "1px solid #EDEDED",
        borderRadius: "8px",
    },
    icon: {
        height: "28px",
        width: "28px",
        color: "#0C0E29",
        marginBottom: "16px",
    },
    title: {
        fontSize: "16px",
        fontFamily: "Lato",
        color: "#0C0E29",
        margin: "0",
    },
    description: {
        fontSize: "16px",
        color: "#0C0E29",
        opacity: "0,8",
        marginTop: "8px",
    },
    button: {
        marginTop: "36px",
    },
}));

const EmptyStateCard = ({ title = "No Data Available", description, actionLabel = "Add Data", onActionClick }) => {
    const classes = useStyles();

    return (
        <div className={classes.card}>
            <div>
                <CircleOff className={classes.icon} />
                <h3 className={classes.title} gutterBottom>
                    {title}
                </h3>
                {description && (
                    <p className={classes.description}>
                        {description}
                    </p>
                )}
                {onActionClick && (
                    <button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={onActionClick}
                    >
                        {actionLabel}
                    </button>
                )}
            </div>
        </div>
    );
};

export default EmptyStateCard;
